import { Component, AfterContentInit, ContentChildren, QueryList } from '@angular/core';
import { TabComponent } from './tab.component';

@Component({
  selector: 'app-tabs',
  standalone: true,
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;

  ngAfterContentInit(): void {
    // Ativar a primeira tab se nenhuma estiver ativa
    const activeTabs = this.tabs.filter(tab => tab.active());
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTab(tab: TabComponent): void {
    // Desativar todas as tabs
    this.tabs.toArray().forEach(t => t.active.set(false));
    // Ativar a tab selecionada
    tab.active.set(true);
  }
}
